<h1 mat-dialog-title>Approve File</h1>
<div mat-dialog-content>
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="favoriteSeason"
    (change)="onRadioClick(favoriteSeason)"
  >
    <mat-radio-button value="1" *ngIf="showKeepInWorklist"
      ><span translate>Keep in Worklist</span></mat-radio-button
    >
    <mat-radio-button value="2" *ngIf="showSendToWorkPath"
      ><span translate>Send to Work Path</span></mat-radio-button
    >
    <mat-radio-button value="3" *ngIf="showReturnToInitiator"
      ><span translate>Return to Initiator</span></mat-radio-button
    >
  </mat-radio-group>

  <mat-card class="card" *ngIf="clickedSendToWorkPath">
    <ngx-datatable
      #table
      class="material"
      [rows]="rows"
      [columns]="columns"
      [columnMode]="ColumnMode.force"
      [headerHeight]="50"
      [footerHeight]="50"
      rowHeight="auto"
      [selected]="selected"
      [selectionType]="type"
      (select)="onSelect($event)"
    >
    </ngx-datatable>
  </mat-card>

  <mat-card class="card" *ngIf="clickedReturnToIniatiator">
    <ngx-datatable
      *ngIf="rows.length"
      #table
      class="material"
      [rows]="rows"
      [columns]="columns"
      [columnMode]="ColumnMode.force"
      [headerHeight]="50"
      [footerHeight]="50"
      rowHeight="auto"
      [selected]="selected"
      [selectionType]="type"
      (select)="onSelect($event)"
    >
    </ngx-datatable>
    <div *ngIf="!rows.length">You are the initiator of this file</div>
  </mat-card>
</div>
<div mat-dialog-actions align="end">
  <div class="buttons">
    <button
      mat-raised-button
      preventDoubleClick
      color="primary"
      (click)="onSubmit()"
      class="two"
      [disabled]="!this.selectedEmp"
    >
      OK
    </button>
    <button mat-raised-button (click)="close()" class="one">Cancel</button>
  </div>
</div>
